<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row loader" v-if="loading" >
      <div class="col align-self-center text-center ">
        <square-loader />
      </div>
    </div>
    <div v-else>
      <div class="row mt-4">
        <h3 class="col-12">{{game.gameName}} du {{convertDate(game.startDate)}},
          {{roundTime}} par tour</h3>
        <button class="btn btn-link"
          v-on:click="replay = false"
          v-if="replay">Revenir au résultat</button>
        <button class="btn btn-link"
          v-on:click="startReplay"
          v-else>Rejouer la partie tour par tour</button>
      </div>
      <div class="row">
        <div class="board-area col-12 col-lg-8">
          <div class="row" v-if="!replay">
            <div class="mt-4 col-12">
              <img src="/static/i_winners.svg" width="100%"/>
            </div>
          </div>
          <div class="row final-scores" v-if="!replay">
            <div class="mt-4 col-12">
              <table class="table table-stripped table-sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Joueur</th>
                    <th>Total</th>
                    <th>% du top</th>
                    <th>Score LCT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(player, index) in playerScores" v-bind:key="player.userId">
                    <td v-if="index === 0"></td>
                    <td v-else><img src="/static/cup.svg" width="30" v-if="index === 1"/>{{index}}
                    </td>
                    <td>{{player.username}}</td>
                    <td>{{player.total}}</td>
                    <td>{{(percentageFromTop(player.total)).toFixed(2)}}%</td>
                    <td v-if="index === 0 || player.scoreLCT == 0"></td>
                    <td v-else>+{{player.scoreLCT}}pts</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <Board v-bind:board="board"
            v-on:tile-moved="tileMoved"
            v-bind:roundNumber="roundNumber"
            v-bind:squareClicked="squareClicked"
            v-bind:horizontal="horizontal"
            v-bind:premium="premium"
            v-on:open-letter-selection="openLetterSelection"
            v-on:click-square="clickSquare"
            v-if="!openedLetterSelection"
          ></Board>
          <div v-if="openedLetterSelection">
            <SelectLetter v-on:close-letter-selection="closeLetterSelection"></SelectLetter>
          </div>
          <div class="row" v-if="replay">
              <div class="col-10" v-if="!openedLetterSelection">
                <GameDraw
                v-bind:draw="draw"
                v-bind:roundNumber="roundNumber"
                v-on:tile-moved="tileMoved"
                v-on:open-letter-selection="openLetterSelection"
                v-on:clear-board="clearBoard"
                v-on:shuffle-draw="shuffleDraw">
                </GameDraw>
              </div>
          </div>
          <div class="row" v-if="replay">
            <div class="col-4">
              <button class="btn btn-link"
                v-on:click="prevRound"
                v-if="roundNumber > 1"
                >Tour précédent</button>
            </div>
            <div class="col-3" v-if="roundNumber <= game.template.rounds.length">
              Tour n°{{roundNumber}}
            </div>
            <div class="col-3" v-else>
              Fin
            </div>
            <div class="col-4">
              <button class="btn btn-link"
                v-on:click="nextRound"
                v-if="roundNumber <= game.template.rounds.length"
                >Tour suivant</button>
            </div>
          </div>
        </div>
        <div class="info-area col-12 col-lg-4">
          <div class="row">
            <div class="col-12">
              <button v-on:click="lobby" class="btn btn-link">
                Retour au salon
              </button>
            </div>
          </div>
          <div class="row" v-if="displayNextGame">
            <div class="col-12">
              <button v-on:click="playNextGame" class="btn btn-link btn-lg">
                Jouer à la prochaine partie
              </button>
            </div>
          </div>
          <div class="d-none d-md-block">
            <GameChatStomp v-bind:gameId="gameId" v-bind:showTime="true"></GameChatStomp>
          </div>
        </div>
      </div>
      <div class="row mt-4">
          <div class="col-12">
            <playerGameSheet v-bind:scores="playerScores"></playerGameSheet>
          </div>
        </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import iam from '../../iam';
import BoardUtils from '../games/BoardUtils';
import BoardGameService from '../games/board-game-service';
import SquareLoader from '../SquareLoader';
import BottomNav from '../BottomNav';
import LoggedUser from '../LoggedUser';
import GameScores from '../games/GameScores';
import Board from '../games/Board';
import GameChatStomp from '../games/GameChatStomp';
import PlayerGameSheet from './PlayerGameSheet';
import GameDraw from '../games/GameDraw';
import SelectLetter from '../games/SelectLetter';

const padZero = n => ((n < 10) ? `0${n}` : n);

export default {
  name: 'EndedGame',
  props: {
    gameId: {
      type: String,
      required: true,
    },
  },
  components: {
    LoggedUser,
    BottomNav,
    SquareLoader,
    GameScores,
    Board,
    GameChatStomp,
    PlayerGameSheet,
    GameDraw,
    SelectLetter,
  },
  data() {
    return {
      loading: true,
      username: iam.getConnectedUser().username,
      game: undefined,
      board: undefined,
      totalTop: 0,
      lastTopWord: undefined,
      lastTopWordPoints: 0,
      playerScores: undefined,
      replay: false,
      roundNumber: 0,
      draw: undefined,
      horizontal: true,
      openedLetterSelection: false,
      squareClicked: undefined,
      premium: iam.isPremiumOrAdmin(),
    };
  },
  computed: {
    displayNextGame() {
      return this.game && this.game.creator === 'auto';
    },
    roundTime() {
      if (this.game.roundTime < 120) {
        return `${this.game.roundTime} s`;
      }
      return `${this.game.roundTime / 60} min`;
    },
  },
  created() {
    this.findGameById(this.gameId)
      .then((game) => {
        this.game = game;
        const rounds = game.template.rounds;
        this.playerScores = this.buildPlayerScores(game.players, rounds);
        this.totalTop = rounds.reduce((acc, r) => acc + r.points, 0);
        const lastRound = rounds[rounds.length - 1];
        this.lastTopWord = lastRound.word;
        this.lastTopWordPoints = lastRound.points;
        this.board = BoardUtils.buildBoard(rounds);
        this.loading = false;
      });
  },
  methods: {
    findGameById(gameId) {
      return this.$http.get(`${process.env.LCT_API_URL}/ended-games/${gameId}`)
        .then(response => response.data);
    },
    percentageFromTop(score) {
      return this.totalTop > 0
        ? (1 - ((this.totalTop - score) / this.totalTop)) * 100
        : 100;
    },
    buildPlayerScores(players, rounds) {
      return players
        .map(userScore => ({
          ...userScore,
          scores: userScore.scores.filter(s => s.roundNumber <= rounds.length),
        }))
        .map(userScore => ({
          ...userScore,
          scores: [...Array(rounds.length).keys()].reduce((acc, round) => {
            const score = userScore.scores.find(s => s.roundNumber === (round + 1));
            return acc.concat(score || {
              roundNumber: round + 1,
              reference: '',
              score: 0,
            });
          }, []),
        }))
        .map(userScore => ({
          ...userScore,
          totalWithoutBonus: userScore.scores.reduce((acc, score) => acc + score.score, 0) || 0,
          total: userScore.scores.reduce((acc, s) => acc + s.score + (s.bonus || 0), 0) || 0,
        }))
        .sort((a, b) => a.total - b.total)
        .concat({
          username: 'TOP',
          total: rounds.reduce((acc, round) => acc + round.points, 0),
          scores: rounds.reduce((acc, round) => acc.concat({
            roundNumber: round.round,
            reference: round.word,
            score: round.points,
          }), []) })
        .reverse();
    },
    convertDate(timestamp) {
      const d = new Date(timestamp);
      return `${d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })} à ${padZero(d.getHours())}h${padZero(d.getMinutes())}`;
    },
    lobby() {
      this.$router.push('/lobby');
    },
    playNextGame() {
      this.$http.get(`${process.env.LCT_API_URL}/lobby`)
        .then((lobbyResponse) => {
          const data = lobbyResponse.data;
          const game = data.games
            .find(g => g.creator === 'auto' &&
              Number(g.roundTime) === Number(this.game.roundTime) &&
              new Date(g.startDate).getTime() > new Date().getTime());
          if (game) {
            this.$http.post(`${process.env.LCT_API_URL}/game-players`, {
              username: iam.getConnectedUser().username,
              picture: iam.getConnectedUser().picture,
              activeGameId: game.id,
            }).then((response) => {
              sessionStorage.setItem(`${game.id}`, `${response.data.id}`);
              this.$router.push(`/games/${game.id}`);
            });
          }
        });
    },
    startReplay() {
      this.roundNumber = 1;
      this.reload();
      this.replay = true;
    },
    nextRound() {
      this.roundNumber = this.roundNumber <= this.game.template.rounds.length
        ? this.roundNumber + 1
        : this.game.template.rounds.length;
      this.reload();
    },
    prevRound() {
      this.roundNumber = this.roundNumber > 1 ? this.roundNumber - 1 : 1;
      this.reload();
    },
    reload() {
      this.board = BoardUtils.buildBoard(this.game.template.rounds.slice(0, this.roundNumber - 1));
      this.draw = this.game.template.rounds[this.roundNumber - 1]
        ? BoardUtils.buildDraw(this.game.template.rounds[this.roundNumber - 1])
        : [];
      this.playerScores = this.buildPlayerScores(this.game.players,
        this.game.template.rounds.slice(0, this.roundNumber - 1));
    },
    endReplay() {
      this.roundNumber = this.game.template.rounds.length;
      this.reload();
      this.replay = false;
    },
    tileMoved(event) {
      if (this.roundNumber === event.roundNumber) {
        if (event.from === 'DrawSquare' && event.to.square != null) {
          const result = BoardGameService.moveDrawToBoard(
            this.draw,
            this.board,
            event.tile.drawIndex,
            event.to.square);
          this.board = result.board;
          this.draw.splice(0, this.draw.length, ...result.draw);
        } else if (event.from.square != null && event.to.square != null) {
          const result = BoardGameService.moveBoardToBoard(
            this.board,
            event.from.square,
            event.to.square,
          );
          this.board = result.board;
        } else if (event.from.square != null && event.to === 'DrawSquare') {
          const result = BoardGameService.moveBoardToDraw(
            this.board,
            this.draw,
            event.drawIndex,
            event.from.square);
          this.board = result.board;
          this.draw.splice(0, this.draw.length, ...result.draw);
        } else if (event.from === 'DrawSquare' && event.to === 'DrawSquare') {
          const result = BoardGameService.moveDrawToDraw(
            this.draw,
            event.tile,
            event.tile.drawIndex,
            event.drawIndex);
          this.draw.splice(0, this.draw.length, ...result.draw);
        } else if (event.from === 'GameTextInput') {
          const result = BoardGameService.moveWordToBoard(
            this.draw,
            this.board,
            event.word,
          );
          this.board = result.board;
          this.draw.splice(0, this.draw.length, ...result.draw);
        }
      }
      const elmnts = document.querySelectorAll('.move-on-drag-over');
      elmnts.forEach(elmnt => elmnt.classList.remove('move-on-drag-over'));
    },
    openLetterSelection(selectingTile) {
      this.openedLetterSelection = true;
      this.selectingTile = selectingTile;
    },
    closeLetterSelection(letter) {
      this.openedLetterSelection = false;
      this.selectingTile.value = letter;
      this.submitWord();
    },
    clearBoard() {
      const result = BoardGameService.clearBoard(this.draw, this.board);
      this.board = result.board;
      this.draw.splice(0, this.draw.length, ...result.draw);
    },
    shuffleDraw() {
      const shuffle = (x) => {
        const a = x;
        for (let i = a.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
      };
      const s = shuffle(this.draw).map((t, index) => {
        const result = { ...t };
        result.drawIndex = index;
        return result;
      });
      this.draw.splice(0, this.draw.length, ...s);
    },
    clickSquare(square) {
      this.squareClicked = {
        row: square.row,
        column: square.column,
      };
    },
  },
};
</script>

<style scoped>
div.loader {
  min-height: 100vh;
}
.final-scores{
  border-bottom: 1px solid grey;
  margin-bottom: 10px;
}
.btn-link{
  color: #CE0F69;
}
</style>



// WEBPACK FOOTER //
// src/components/ended/EndedGame.vue